import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

// Import Containers
import { FullLayoutComponent } from "./containers";
import { AuthNavGuard } from "./auth";

export const routes: Routes = [
  {
    path: "",
    redirectTo: "dashboard",
    pathMatch: "full",
  },
  // {
  //   path : 'webinars',
  //   redirectTo: 'experiences',
  //   pathMatch: 'full'
  // },
  {
    path: "",
    component: FullLayoutComponent,
    data: {
      title: "Home",
    },
    children: [
      {
        path: "dashboard",
        loadChildren: "./views/dashboard/dashboard.module#DashboardModule",
      },
      {
        path: "recruiting",
        loadChildren: "./views/jobOffers/jobOffers.module#JobOffersModule",
      },
      {
        path: "events",
        loadChildren: "./views/events/events.module#EventsModule",
      },
      {
        path: "articles",
        loadChildren: "./views/posts/posts.module#PostsModule",
      },
      {
        path: "polls",
        loadChildren: "./views/polls/polls.module#PollsModule",
      },
      {
        path: "candidates",
        loadChildren: "./views/candidates/candidates.module#CandidatesModule",
      },
      {
        path: "chat",
        loadChildren: "./views/chat/chat.module#ChatModule",
      },
      {
        path: "profile",
        loadChildren: "./views/profile/profile.module#ProfileModule",
      },
      {
        path: "reports",
        loadChildren: "./views/reports/reports.module#ReportsModule",
      },
      {
        path: "dataloop",
        loadChildren: "./views/dataloop/dataloop.module#DataloopModule",
      },
      {
        path: "taleo",
        loadChildren: "./views/taleo/taleo.module#TaleoModule",
      },
      // webinar
      {
        path: "experiences",
        loadChildren: "./views/webinars/webinars.module#WebinarsModule",
      },
      // digital career days
      {
        path: "career_days",
        loadChildren:
          "./views/digital-career-days/digital-career-days.module#DigitalCareerDaysModule",
      },
      // pdf download
      {
        path: "pdf-download",
        loadChildren:
          "./views/pdf-download/pdf-download.module#PdfDownloadModule",
      },
      {
        path: "welcome",
        loadChildren: "./views/welcome/welcome.module#WelcomeModule",
      },
    ],
    canActivate: [AuthNavGuard],
  },
  {
    path: "login",
    loadChildren: "./views/login/login.module#LoginModule",
  },
  {
    path: "recover-password",
    loadChildren:
      "./views/recover-password/recover-password.module#RecoverPasswordModule",
  },
  {
    path: "reset-password",
    loadChildren:
      "./views/reset-password/reset-password.module#ResetPasswordModule",
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
